import React, { useState } from "react";
import { useEngagement } from "@/contexts/EngagementContext";
import { Briefcase, ChevronDown, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

const EngagementSwitcher = () => {
  const { engagements, activeId, active, setActiveId } = useEngagement();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  return (
    <div className="relative">
      <button
        data-testid="engagement-switcher"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-1.5 border border-slate-800 hover:border-cyan-500/60 transition-all bg-slate-950/60"
      >
        <Briefcase className="h-3.5 w-3.5 text-cyan-400" />
        <div className="text-left leading-tight">
          <div className="text-[9px] uppercase tracking-[0.3em] text-slate-500">ENGAGEMENT</div>
          <div className="text-xs text-slate-100 truncate max-w-[200px]">
            {active?.name || "Demo Environment"}
          </div>
        </div>
        <ChevronDown className="h-3 w-3 text-slate-500" />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 w-80 bg-slate-950 border border-slate-800 shadow-[0_0_24px_rgba(6,182,212,0.15)] z-50">
            <div className="px-3 py-2 border-b border-slate-800 text-[10px] uppercase tracking-[0.3em] text-cyan-400">
              Switch Engagement
            </div>
            <ul className="max-h-96 overflow-y-auto">
              {engagements.map((e) => {
                const isDemo = e.id === "demo-default";
                const isActive = e.id === activeId;
                return (
                  <li key={e.id}>
                    <button
                      data-testid={`engagement-option-${e.id}`}
                      onClick={() => setActiveId(e.id)}
                      className={[
                        "w-full text-left px-3 py-2.5 hover:bg-slate-900 transition-all border-l-2",
                        isActive ? "border-cyan-400 bg-cyan-500/5" : "border-transparent",
                      ].join(" ")}
                    >
                      <div className="flex items-center justify-between gap-2">
                        <div className="min-w-0 flex-1">
                          <div className="text-sm text-slate-100 truncate">{e.name}</div>
                          <div className="text-[10px] text-slate-500 truncate">{e.client_name}</div>
                        </div>
                        {isDemo && (
                          <span className="text-[9px] uppercase tracking-widest px-1.5 py-0.5 border border-amber-500/60 text-amber-300 bg-amber-500/10">
                            DEMO
                          </span>
                        )}
                        {e.status === "archived" && (
                          <span className="text-[9px] uppercase tracking-widest text-slate-500">archived</span>
                        )}
                      </div>
                    </button>
                  </li>
                );
              })}
            </ul>
            <button
              data-testid="new-engagement-btn"
              onClick={() => { setOpen(false); nav("/engagements"); }}
              className="w-full text-left px-3 py-2.5 border-t border-slate-800 text-cyan-300 hover:bg-cyan-500/5 flex items-center gap-2"
            >
              <Plus className="h-3.5 w-3.5" />
              <span className="text-xs uppercase tracking-widest">Manage engagements</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EngagementSwitcher;
